import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';

export default function BreederProfileParentDogsCarouselSkeleton() {
  return (
    <div className="BreederProfileParentDogsCarouselSkeleton container-xxl overflow-hidden">
      <SkeletonBlock className="font-24 mt2 mb4" height="1em" width="6em" />
      <ul className="flex gap-16 nr6">
        {makeSequence(3).map(index => (
          <li key={index}>
            <div
              className="br4 ba b--default pt2 ph2"
              style={{ width: '80vw' }}
            >
              <div className="aspect-ratio--8x5 relative">
                <div className="aspect-ratio--object">
                  <SkeletonBlock className="br3" height="100%" />
                </div>
              </div>
              <div className="pv4 ph2">
                <SkeletonBlock
                  className="font-20 mb1"
                  height="1em"
                  width="6em"
                />
                <SkeletonBlock
                  className="font-16 mb4"
                  height="1em"
                  width="7em"
                />
                <SkeletonBlock
                  className="font-16 mb2"
                  height="1em"
                  width="6em"
                />
                <div className="flex flex-column gap-4 mb4">
                  {makeSequence(4).map(i => (
                    <SkeletonBlock key={i} className="font-12" height="1em" />
                  ))}
                </div>
                <SkeletonBlock className="br3" height="80px" />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
